import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "record-table__scroll" }
const _hoisted_2 = { class: "record-table" }
const _hoisted_3 = { scope: "col" }
const _hoisted_4 = ["data-label"]
const _hoisted_5 = {
  "data-test": "cell",
  "data-label": "Orders",
  class: "record-table__num"
}
const _hoisted_6 = {
  "data-test": "cell",
  "data-label": "Gross",
  class: "record-table__num"
}
const _hoisted_7 = {
  "data-test": "cell",
  "data-label": "Refunds",
  class: "record-table__num"
}
const _hoisted_8 = {
  "data-test": "cell",
  "data-label": "Net",
  class: "record-table__num"
}
const _hoisted_9 = { "data-test": "periods-count" }

import { computed, ref, watch } from 'vue'

import RecordButton from '@/components/customers/record/RecordButton.vue'
import RecordTableCard from '@/components/customers/record/RecordTableCard.vue'
import { formatDollars } from '@/helpers/money'

const PAGE_SIZE = 6

export default {
  __name: 'RevenuePeriodTable',
  props: {
  periods: { type: Array, required: true },
  groupBy: { type: String, required: true }
},
  setup(__props) {

const NOUNS = { day: 'Day', week: 'Week', month: 'Month', year: 'Year' }

const props = __props

const expanded = ref(false)

const noun = computed(() => NOUNS[props.groupBy] ?? NOUNS.month)
const heading = computed(() => `${noun.value} by ${noun.value.toLowerCase()}`)
const visiblePeriods = computed(() => (expanded.value ? props.periods : props.periods.slice(0, PAGE_SIZE)))

watch(
  () => [props.periods, props.groupBy],
  () => {
    expanded.value = false
  }
)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(RecordTableCard, {
    "data-test": "period-table",
    title: heading.value
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_3, _toDisplayString(noun.value), 1),
              _cache[1] || (_cache[1] = _createElementVNode("th", {
                scope: "col",
                class: "record-table__num"
              }, "Orders", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("th", {
                scope: "col",
                class: "record-table__num"
              }, "Gross", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("th", {
                scope: "col",
                class: "record-table__num"
              }, "Refunds", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("th", {
                scope: "col",
                class: "record-table__num"
              }, "Net", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePeriods.value, (period) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: period.key,
                "data-test": "period-row"
              }, [
                _createElementVNode("td", {
                  "data-test": "cell",
                  "data-label": noun.value,
                  class: "record-table__primary"
                }, _toDisplayString(period.label), 9, _hoisted_4),
                _createElementVNode("td", _hoisted_5, _toDisplayString(period.orders), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(formatDollars)(period.gross)), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(formatDollars)(period.refunds)), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formatDollars)(period.net)), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 2
  }, [
    (__props.periods.length > PAGE_SIZE)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("span", _hoisted_9, "Showing " + _toDisplayString(visiblePeriods.value.length) + " of " + _toDisplayString(__props.periods.length), 1),
            _createVNode(RecordButton, {
              "data-test": "show-all-periods",
              class: "ml-auto",
              size: "sm",
              onClick: _cache[0] || (_cache[0] = $event => (expanded.value = !expanded.value))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(expanded.value ? 'Show fewer' : 'Show all'), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["title"]))
}
}

}